import React from 'react';
import { ToastContainer, toast } from 'react-toastify';

const Notifications = () => (
  <ToastContainer
    position={toast.POSITION.TOP_CENTER}
    autoClose={false}
    closeOnClick={false}
  />
);

export default Notifications;
